import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsStock from "highcharts/modules/stock";

// Initialize the Highcharts stock module
HighchartsStock(Highcharts);
HighchartsMore(Highcharts);


const LineChart = () => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    // Fetch data from the Highcharts demo API
    fetch("https://demo-live-data.highcharts.com/aapl-c.json")
      .then((response) => response.json())
      .then((data) => {
        const formattedData = data.map((item) => [item[0], item[1]]);
        setChartData(formattedData);
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      });
  }, []);

  // Highcharts chart options
  const options = {
    chart: {
      type: "line",
    },
    title: {
      text: "Technology Stock Price",
    },
    xAxis: {
      type: "datetime", // X-axis is time-based (timestamps)
      title: {
        text: "Date",
      },
    },
    yAxis: {
      title: {
        text: "Price (USD)",
      },
    },
    series: [
      {
        name: "Technology Stock",
        data: chartData, // Data fetched from the API
        tooltip: {
          valueDecimals: 2,
        },
      },
    ],
    tooltip: {
      xDateFormat: "%Y-%m-%d %H:%M:%S",
      pointFormat: "{point.y} USD",
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,
        },
        enableMouseTracking: true,
      },
    },
    rangeSelector: {
      selected: 1, // Set default selection to '3m'
      buttons: [
        {
          type: "month",
          count: 1,
          text: "1M",
        },
        {
          type: "month",
          count: 3,
          text: "3M",
        },
        {
          type: "month",
          count: 6,
          text: "6M",
        },
        {
          type: "year",
          count: 1,
          text: "YTD", // Year to Date
        },
        {
          type: "year",
          count: 1,
          text: "1Y",
        },
        {
          type: "all",
          text: "ALL",
        },
      ],
      inputEnabled: true, // Disable manual input for date range
      buttonTheme: {
        width: 60,
      },
    },
    navigator: {
      enabled: true, // Enable navigator for further zooming and panning
    },
    credits: {
      enabled: false, // Disable Highcharts.com watermark
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default LineChart;
